module.exports = __webpack_public_path__ + "img/pic1.859fc187.png";